"use client";
import { createContext, ReactNode, useContext, SetStateAction, useState, useEffect } from "react";
import { usePathname } from "next/navigation";

interface IContextType {
    mainMenu: boolean;
    subMenu: boolean,
    search: boolean,
    account : boolean,
    setMainMenu: React.Dispatch<SetStateAction<boolean>>;
    setSubMenu: React.Dispatch<SetStateAction<boolean>>;
    setSearch: React.Dispatch<SetStateAction<boolean>>;
    setAccount: React.Dispatch<SetStateAction<boolean>>;
    resetMenuContext: React.Dispatch<SetStateAction<boolean>>;
}

export const INITIAL_MENU_DATA = {
    mainMenu: false,
    setMainMenu: () => false,
    subMenu: false,
    setSubMenu: () => false,
    search: false,
    setSearch: () => false,
    account : false,
    setAccount: () => false,
    resetMenuContext: () => false,
};

const MenuContext =  createContext<IContextType>(INITIAL_MENU_DATA);

export const MenuProvider = ({ children }: { children: React.ReactNode }) => {
  const [mainMenu, setMainMenu] = useState(false);
  const [subMenu, setSubMenu] = useState(false);
  const [search, setSearch] = useState(false);
  const [account, setAccount] = useState(false);
  const pathname = usePathname();

  const resetMenuContext = () => {
    setMainMenu(false);
    setSubMenu(false);
    setSearch(false);
    setAccount(false);
  }

 useEffect(() => {
   resetMenuContext();
 }, [pathname]);



  return <MenuContext.Provider value={{ mainMenu, setMainMenu, subMenu, setSubMenu, search, setSearch, account, setAccount, resetMenuContext }}>{children}</MenuContext.Provider>;
};

export const useMenu = () => useContext(MenuContext);
